import React, { useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import Topbar from '../../../PulseSurvey/Topbar';
import { useOutsideClick } from '../../../../utils/helper';
import PartnerList from "../../../../container/B2B/B2BAdmin/Partnership/Partners/partner";
import PartnerIntroDuced from "../../../../container/B2B/B2BAdmin/Partnership/PartnerIntroduced/partnerIntroduced"

const   PartnersPage = () => {
  const ref2 = useRef(null);
  const calendarRef = useRef(null);
  const selectedTheme = JSON.parse(localStorage.getItem('selectedTheme'));
  const [isOpen2, setIsOpen2] = useState(false);

  const peapMangementPages = [
    { name: 'Partner List', value: 1 },
    { name: 'Partner Introduced', value: 2 }
  ];

  const [selectedPage, setSelectedPage] = useState(peapMangementPages[0]);

  useOutsideClick(calendarRef, () => {
    setIsOpen2(false);
  });

  const handleMenuSelect = (item) => {
    console.log(item,"selected item");
    setSelectedPage(item);
    setIsOpen2(false);
  };

  return (
    <div className="relative lg:mb-[45px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Shoorah | Partners</title>
      </Helmet>
      <Topbar title={'Partners'} />

      <div className="sm:flex flex-col md:flex-row mt-3 justify-between items-center gap-3">
        <div className="flex flex-row items-center justify-center mt-2 sm:mt-0 space-y-2 sm:space-y-0 sm:space-x-2 w-full sm:w-auto">
          <div ref={ref2} className="relative inline-block text-left w-full md:w-auto mb-2 md:mb-0">
            <button
              type="button"
              onClick={() => setIsOpen2(!isOpen2)}
              className="flex justify-between items-center w-full md:w-auto px-5 py-2 text-xs md:text-base font-medium border dark:border-text-shoorah-darkBg border-[#0B1D2E] rounded-full dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
            >
              <span>{selectedPage.name}</span>
              {selectedTheme ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                    stroke="#F3F4F6"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                    stroke="#0B1D2E"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </button>

            {isOpen2 && (
              <div
                className="z-50 absolute top-[2.5em] left-0 w-full sm:w-auto transform scale-90 sm:scale-100  mt-1 p-2 bg-white shadow-lg ring-1 ring-[#E7EAE8] dark:bg-shoorah-darkBgColor rounded-md"
                ref={calendarRef}
              >
                <ul className="bg-white dark:bg-shoorah-darkBgColor text-sm rounded-md divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                  {peapMangementPages.map((item) => (
                    <li
                      key={item.value}
                      className="px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-800 cursor-pointer"
                      onClick={() => handleMenuSelect(item)}
                    >
                      {item.name}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      <div>
        {selectedPage?.value === 1 && 
        <PartnerList topbarShow={false}  />
        }
        {selectedPage?.value === 2  &&
        <PartnerIntroDuced topbarShow={false} />
        }
        </div>

    </div>
  );
};

export default   PartnersPage;
